export default "__VITE_ASSET__DHzFeeRV__"